import { FC, Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';
import MoTable from './MoTable';
import Tabs from 'components/ui/Tabs/Tabs';

interface SkeletonMyOrdersProps {
  step: 1 | 2 | 3;
}

const SkeletonMyOrders: FC<SkeletonMyOrdersProps> = ({ step }) => {
  return (
    <Fragment>
      {step === 1 && (
        <div className="form-wrapper row">
          {[...Array(12)].map((_, index) => (
            <div className="col-md-3 col-12 mb-15" key={index}>
              <Skeleton height={36} width={'100%'} />
            </div>
          ))}
        </div>
      )}

      {step === 2 && (
        <Fragment>
          <Tabs
        size="small"
            label="Orders"
            value="0"
            items={[{ value: '0', label: 'Orders' }]}
          />
          <MoTable rows={10} cols={10} />
        </Fragment>
      )}

      {step === 3 && (
        <div className="mo-details">
          <div className="title mb-30 display-flex">
            <Skeleton
              width={220}
              height={24}
              style={{ display: 'inline-block', marginInlineEnd: 5 }}
            />
            <Skeleton width={37} height={32} style={{ display: 'inline-block' }} />
          </div>
          <div className="mb-20">
            <Skeleton width={180} height={16} />
          </div>
          <MoTable rows={1} cols={10} />
          <MoTable rows={2} cols={9} />
          <div className="mb-10 mt-30">
            <Skeleton width={180} height={16} />
          </div>
          <MoTable rows={3} cols={10} />
        </div>
      )}
    </Fragment>
  );
};

export default SkeletonMyOrders;
